import { useEffect, useState } from "react";
import { Trophy, Medal } from "lucide-react";
import { api } from "@/lib/api";
import { SPORT_LABEL } from "@/lib/format";

const MEDAL = { 1: "text-yellow-400", 2: "text-slate-300", 3: "text-amber-600" };

export const ResultsSection = () => {
  const [cats, setCats] = useState([]);
  const [tab, setTab] = useState(null);
  useEffect(() => { api.get("/public/results").then((r) => r.data.published && setCats(r.data.categories)).catch(() => {}); }, []);
  if (!cats.length) return null;
  const sports = [...new Set(cats.map((c) => c.sport_type))];
  const active = tab || sports[0];
  return (
    <section className="border-t border-white/10 py-16 sm:py-24 bg-surface/30" data-testid="results-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <p className="text-brand font-bold uppercase tracking-widest text-sm flex items-center gap-2"><Trophy className="w-4 h-4" /> Classificação oficial</p>
        <h2 className="font-display text-4xl sm:text-5xl font-extrabold uppercase tracking-tight mb-8">Resultados da Prova</h2>
        <div className="flex gap-2 mb-6 overflow-x-auto">
          {sports.map((s) => (
            <button key={s} data-testid={`results-tab-${s}`} onClick={() => setTab(s)}
              className={`px-4 py-2 rounded-full border text-sm font-bold uppercase tracking-wide whitespace-nowrap transition-colors ${active === s ? "bg-brand border-brand text-white" : "border-white/10 text-slate-300 hover:border-brand/50"}`}>
              {SPORT_LABEL[s] || s}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {cats.filter((c) => c.sport_type === active).map((c) => (
            <div key={c.category_id} className="rounded-2xl bg-ink border border-white/10 overflow-hidden">
              <div className="px-5 py-3 border-b border-white/10 font-display uppercase font-bold text-lg">{c.category}</div>
              <table className="w-full text-sm">
                <tbody>
                  {c.results.slice(0, 10).map((r) => (
                    <tr key={r.bib_code} className="border-b border-white/5 odd:bg-surface/40">
                      <td className="px-5 py-2.5 w-14 font-display font-black text-lg">{r.position <= 3 ? <Medal className={`w-5 h-5 inline ${MEDAL[r.position]}`} /> : `${r.position}º`}</td>
                      <td className="px-3 py-2.5 font-mono text-neon text-xs">{r.bib_code}</td>
                      <td className="px-3 py-2.5 font-semibold">{r.name}</td>
                      <td className="px-5 py-2.5 font-mono text-right">{r.time}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ResultsSection;
